/**
 * Matcha FAQ — single-open accordion behaviour on product FAQ pages.
 */
class MatchaFaq extends HTMLElement {
  #bound = false;

  connectedCallback() {
    if (this.#bound) return;
    this.#bound = true;

    const items = this.querySelectorAll('.matcha-faq__item');
    if (!items.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;

        items.forEach((other) => {
          if (other !== item && other.open) {
            other.open = false;
          }
        });
      });
    });
  }
}

if (!customElements.get('matcha-faq')) {
  customElements.define('matcha-faq', MatchaFaq);
}
